import React, {useEffect, useState} from 'react';
import {get} from '../../../api';
import CurrencyNumber from '../../cmp/CurrencyNumber';
import {FormattedMessage} from 'react-intl';
import StatisticItem from '../cmp/StatisticItem';
import {connect} from "react-redux";
import LazyRangePicker from "../../cmp/flatpickr/LazyRangePicker";
import Big from 'big.js'
import dayjs from '../../../mydayjs';
const opts = ['Visits', 'Orders', 'Conversions', 'Sales', 'Earnings'];

function AffiliateSalesSection({created, aff_summary_widget, aff_summary_default_dates}){
    const [data, setData] = useState(null);
    const [dates, setDates] = useState(aff_summary_default_dates || [
        dayjs().startOf('year').toDate(),
        new Date()
    ])
    useEffect(()=>{
        if(aff_summary_default_dates) {
            setDates(aff_summary_default_dates)
        }
    },[aff_summary_default_dates])
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        if(aff_summary_widget.length > 0) {
            const starttime = new Date(dates[0]).getTime();
            const endtime = new Date(dates[1]).getTime();
            setLoading(true)
            const sp = aff_summary_widget.some((i)=>i.includes('Subscription')) ? get('/sales/subscription_stats') : Promise.resolve({})
            const abortController = new AbortController()
            Promise.all([
                get(`/mlm/stats/${starttime}/${endtime}`, null, abortController),
                get(`/sales/summary/${starttime}/${endtime}`, null, abortController),
                sp,
            ]).then((d) => {
                const {amount, team_sales, target_bonus} = d[0];
                const {num_orders, referrals} = d[1];
                const {subscription_stats} = d[2]
                const conversion = referrals > 0 ? Big(num_orders || 0).div(referrals || 1).times(100).round(2) : 0;
                setData({
                    target_bonus,
                    mlm_amount: amount, team_sales,
                    ...d[1],
                    subscription_stats,
                    conversion: (conversion > 10 ? Math.round(conversion) : Big(conversion)) + "%"
                })
                setLoading(false)
            })
            return ()=>{
                abortController.abort()
            }
        }
    },[dates])
    if(aff_summary_widget.length === 0) return <div className={'my-4'}/>;
        return (
            <div className={'my-4'}>
                <div className={'row'}>
                    <div className={'col-sm-6 col-md-8'}>
                        <h3 className={'my-2'}><FormattedMessage id={'summary'}/></h3>
                    </div>
                    <div className={'col-sm-6 col-md-4'}>
                        <div className={'form-group'}>
                            <LazyRangePicker onChange={setDates} startDate={dates && dates[0]} endDate={dates && dates[1]}/>
                        </div>
                    </div>
                </div>
                <CardInfo {...data} loading={loading} aff_summary_widget={aff_summary_widget}/>
            </div>
        );
}


function CardInfo({aff_summary_widget, loading, subscription_stats, referrals, num_orders, net_earnings, conversion, revenue, commission, team_sales, mlm_amount, target_bonus}) {
    const parts = {
        'Visits': <StatisticItem key={"visits"} value={referrals} id={'Referrals'} loading={loading}/>,
        'Orders': <StatisticItem key={"orders"} value={num_orders} id={'Orders'} loading={loading}/>,
        'Conversions': <StatisticItem key={"conversions"} value={conversion} id={'Conversions'} loading={loading}/>,
        'Sales': <StatisticItem key={"sales"} value={<CurrencyNumber value={roundIfLarge(revenue)}/>} id={'Sales'}
                                loading={loading}/>,
        'Sale Earnings':<StatisticItem key={'sale_commission'}
                               value={<CurrencyNumber value={roundIfLarge(Number((commission || 0)))}/>}
                               id={'Earnings'}
                               loading={loading}/>,
        'Earnings': <StatisticItem key={"earnings"}
                                   value={<CurrencyNumber value={roundIfLarge(Number(commission) + Number(mlm_amount))}/>}
                                   id={'Earnings'} loading={loading}/>,
        'Team Earnings': <StatisticItem key={"mlm_amount"}
                                   value={<CurrencyNumber value={roundIfLarge(Number(mlm_amount))}/>}
                                   id={'Team Earnings'} loading={loading}/>,
        'Net Earnings':<StatisticItem key={"net_earnings"}
                                      value={<CurrencyNumber value={roundIfLarge(Number(net_earnings))}/>}
                                      id={'Net earnings'} loading={loading}/>,
        'Team sales': <StatisticItem key={'team_sales'}
                                     value={<CurrencyNumber value={roundIfLarge(Number(team_sales || 0))}/>}
                                     id={'Team sales'}
                                     loading={loading}/>,
        'Bonus':<StatisticItem key={'target_bonus'}
                               value={<CurrencyNumber value={roundIfLarge(Number(target_bonus || 0))}/>}
                               id={'Bonus'}
                               loading={loading}/>,
        'Active Subscriptions':<StatisticItem key={'active_subscriptions'}
                               value={Number(subscription_stats?.count || 0)}
                               id={'Active Subscriptions'}
                               loading={loading}/>,
        'Predicted Subscription Volume':<StatisticItem key={'predicted_subscription_volume'}
                               value={<CurrencyNumber value={roundIfLarge(Number(subscription_stats?.subtotal || 0))}/>}
                               id={'Subscription Sales'}
                               loading={loading}/>,
        'Predicted Subscription Earnings':<StatisticItem key={'predicted_subscription_earnings'}
                               value={<CurrencyNumber value={roundIfLarge(Number(subscription_stats?.commission || 0))}/>}
                               id={'Subscription Earnings'}
                               loading={loading}/>
    }

    if(aff_summary_widget.length > 5){
        return (<div className={'row flex-wrap'}>
            {
                aff_summary_widget.map((key) => {
                    return <div key={key} className={"col-lg-3 col-md-4 col-sm-6 mb-3"}>{parts[key]}</div>
                })
            }
        </div>);
    }else{
        return (<div className={'card-group'}>
            {
                aff_summary_widget.map((key) => {
                    return parts[key]
                })
            }
        </div>);
    }

}

function roundIfLarge(num){
    if(String(num).length > 5){
        return Math.round(num)
    }else return num;
}

function mapStateToProps(state) {
    return {
        aff_summary_widget: state.settings.aff_summary_widget ? JSON.parse(state.settings.aff_summary_widget) : opts,
        created: state.settings.created,
        aff_summary_default_dates: state.settings.aff_summary_default_dates,
    }
}


export default connect(mapStateToProps)(AffiliateSalesSection);
